export default __webpack_public_path__ + "static/media/DollarInspect.06ad4697.svg";